let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f1ntI")).then(() => parcelRequire('89Ehy'));